import "./details.css"
import { Card, Col, ProgressBar, Row } from "react-bootstrap";
import { FaRegCalendarAlt } from "react-icons/fa";
import { TbFlame, TbMoneybag } from "react-icons/tb";
import CommonUtils from "../../../utils/common";
import { BsQuestionLg } from "react-icons/bs";
import { SlEnergy } from "react-icons/sl";
import { MdOutlineOilBarrel, MdOutlineSolarPower } from "react-icons/md";

const ContractCard = ({ elv, energieprodukt }) => {

    const UTILS = new CommonUtils();

    const anlage = elv?.x_anlage_id;
    const energyForm = anlage?.x_studio_field_3eKe0;
    const startDate = elv?.x_belbeg;
    const endDate = elv?.x_datum_vertragsende;
    let contractEnded = false;

    var colorSchema = "muted"
    var contractProgress = 0;
    const energyIconSize = 40;
    var icon = <BsQuestionLg size={energyIconSize} />


    // Calculates where is now from start to end of contract.
    // In case that contract has endDate set to False it takes
    // 1 year plus from start date.
    if (startDate) {
        const start = new Date(startDate);
        const end = (endDate && endDate !== "False")
            ? new Date(endDate)
            : new Date(new Date(start).setFullYear(start.getFullYear() + 1));

        const now = new Date()

        const totalDuration = end - start;
        const elapsedDuration = now - start;

        contractProgress = Math.round((elapsedDuration / totalDuration) * 100);
        contractProgress = Math.max(0, Math.min(100, contractProgress));
        contractEnded = now >= end;
    }

    // Setting color scheme and icon depending on energy
    if (energyForm === "Strom") {
        colorSchema = "energo";
        icon = <SlEnergy size={energyIconSize} className="text-energo" />
    }
    else if (energyForm === "Gas") {
        colorSchema = "info";
        icon = <TbFlame size={energyIconSize} className="text-info" />
    }
    else if (energyForm === "Oil") {
        colorSchema = "danger";
        icon = <MdOutlineOilBarrel size={energyIconSize} className="text-danger" />
    }
    else if (energyForm === "Strom-Einspeisung") {
        colorSchema = "warning";
        icon = <MdOutlineSolarPower size={energyIconSize} className="text-warning" />
    }

    const download_preisblatt = (e) => {
        e.preventDefault();
        if (energieprodukt.x_file_preisblatt && energieprodukt.x_file_preisblatt !== "False") {
            var linksource = `data:application/pdf;base64,${energieprodukt.x_file_preisblatt}`;
            var fileName = energieprodukt.x_file_preisblatt_name;
            const downloadLink = document.createElement('a');
            downloadLink.href = linksource;
            downloadLink.download = fileName;
            downloadLink.click();
        }
    }


    // GUI
    return (
        <Card className="radius-20 shadow-lg">
            <ProgressBar
                className="contract-card-progressbar"
                variant={contractEnded? "secondary" : colorSchema}
                now={contractProgress}
            />
            <Card.Body>
                <Row className="mt-1">
                    <Col>
                        <div className="d-flex align-items-center gap-2">
                            {icon}
                            <h5>
                                {elv.x_energieprodukt_id[1]}
                                {elv.x_is_leerstand && <b> : Leerstand</b>}
                            </h5>
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <div className="d-flex align-items-center gap-3 mx-3 h-100">
                            <TbMoneybag size={25} />
                            <div className="d-flex flex-column">
                                {elv.x_teilvorschreibung_brutto !== "" && elv.x_teilvorschreibung_brutto !== "False" && Number(elv.x_teilvorschreibung_brutto) > 0 &&
                                    <div><small className="text-muted">Teilvorschreibung brutto: </small> {Number(elv.x_teilvorschreibung_brutto).toFixed(2)}</div>
                                }
                                {energieprodukt.x_preis_kwh > 0 &&
                                    <>
                                        <div><small className="text-muted">Preis pro kWh exkl. USt: </small> {energieprodukt.x_preis_kwh.toFixed(2)} ct</div>
                                        <div><small className="text-muted">Grundgebühr/Monat exkl. USt: </small> {energieprodukt.x_preis_grundgeb.toFixed(2)} €</div>
                                    </>
                                }
                                {energieprodukt.x_preis_kwh_rabattiert > 0 &&
                                    <div><small className="text-muted">Preis pro kWh inkl. Rabatt: </small> {energieprodukt.x_preis_kwh_rabattiert.toFixed(4)} ct</div>
                                }
                                {energieprodukt.x_preisinfo !== "" && energieprodukt.x_preisinfo !== "False" &&
                                    <div><small className="text-muted">Preis info: </small> {energieprodukt.x_preisinfo}</div>
                                }
                                <div><small className="text-muted">Abrechnung: </small> {elv.x_monthly_invoice ? "Monatlich" : "Jährlich"}</div>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className="d-flex align-items-center gap-3 mx-3 h-100">
                            <FaRegCalendarAlt size={25} />
                            <div className="d-flex flex-column mx-3">
                                {energieprodukt.x_vertragsbindung !== "" && energieprodukt.x_vertragsbindung !== "False" && energieprodukt.x_vertragsbindung !== "0" &&
                                    <div><small className="text-muted">Vertragsbindung: </small> {energieprodukt.x_vertragsbindung} Monate</div>
                                }
                                <div><small className="text-muted">Belieferungsbeginn: </small> {UTILS.dateToEuFormat(elv.x_belbeg)}</div>
                                <div><small className="text-muted">Vertragsende: </small> {UTILS.dateToEuFormat(elv.x_datum_vertragsende)}</div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row className="mt-3">
                    <Col xs="12" md="6" xl="6" className="border-right px-4">
                        <b>Vertragsdaten</b>
                        <table className="elv-detail-table">
                            <tbody>
                                <tr>
                                    <td>Vertrag auf:</td>
                                    <td>{elv.x_kunde_id[1]}</td>
                                </tr>
                                <tr>
                                    <td>Vertragsabschluss:</td>
                                    <td>{UTILS.dateToEuFormat(elv.x_datum_vertragsabschluss)}</td>
                                </tr>
                                <tr>
                                    <td>Energieprodukt:</td>
                                    <td>{energieprodukt.x_name}</td>
                                </tr>
                                <tr>
                                    <td>Energielieferant:</td>
                                    <td>{energieprodukt.x_energielieferant_id[1]}</td>
                                </tr>
                                {energieprodukt.x_produkteigenschaft !== "False" &&
                                    <tr>
                                        <td>Produkteigenschaft:</td>
                                        <td>{energieprodukt.x_produkteigenschaft}</td>
                                    </tr>
                                }
                                <tr>
                                    <td>Vertragsart:</td>
                                    <td>{energieprodukt.x_vertragsart}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Col>
                    <Col xs="12" md="6" xl="6" className="px-4">
                        <b>Anlage</b>
                        <table className="elv-detail-table">
                            <tbody>
                                <tr>
                                    <td>Energieform:</td>
                                    <td>{energyForm}</td>
                                </tr>
                                <tr>
                                    <td>Smartmeter</td>
                                    <td>{UTILS.checkUncheckIcons(anlage.x_is_smartmeter_01)}</td>
                                </tr>
                                <tr>
                                    <td>Zählernummer:</td>
                                    <td>{anlage.x_zaehlernummer_01}</td>
                                </tr>
                                <tr>
                                    <td>Zählpunktnummer:</td>
                                    <td>{anlage.x_zaehlpunktnummer_01}</td>
                                </tr>
                                {anlage.x_zaehlernummer_02 !== "" && anlage.x_zaehlernummer_02 !== "False" &&
                                    <tr>
                                        <td>Zählernummer 2:</td>
                                        <td>{anlage.x_zaehlernummer_02}</td>
                                    </tr>
                                }
                                {anlage.x_zaehlpunktnummer_02 !== "" && anlage.x_zaehlpunktnummer_02 !== "False" &&
                                    <tr>
                                        <td>Zählpunktnummer 2:</td>
                                        <td>{anlage.x_zaehlpunktnummer_02}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col className="px-4">
                        <b>Rechnungsadresse</b>
                        <table className="elv-detail-table">
                            <tbody>
                                <tr>
                                    <td>Straße:</td>
                                    <td>{elv.x_address_street}</td>
                                </tr>
                                <tr>
                                    <td>PLZ:</td>
                                    <td>{elv.x_address_plz}</td>
                                </tr>
                                <tr>
                                    <td>Ort:</td>
                                    <td>{elv.x_address_city}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>
                {energieprodukt.x_file_preisblatt_name !== "False" && energieprodukt.x_file_preisblatt_name !== "" &&
                    <Row className="mt-3">
                        <Col className="text-center">
                            <small className="text-muted">
                                Detaillierte Informationen zu Ihren Energieliefervertrag können Sie dem&nbsp;
                                <a onClick={e => download_preisblatt(e)} href="/energieliefervertrag/infoblatt" className="link-energo">Preisblatt</a> entnehmen
                            </small>
                        </Col>
                    </Row>
                }
            </Card.Body>
        </Card>
    )
}
export default ContractCard;